<template lang="html">
  <div v-if="enable"
    class="bar"
    :class="{ 'bar-large': isPlaceholderVisible }">
    <nav :class="{ 'bar-large': isPlaceholderVisible }">
      <div v-if="isPlaceholderVisible" class="loan-holder"></div>
      <div style="position: relative;">
        <img v-if="top || true" src="../assets/icons/back.png" @click="back"/>
        <h1>{{ title }}</h1>
      </div>
    </nav>
  </div>
</template>

<script>
import barBus from '../bar/bus'
import os from '@edu-fe/os'

import { isTop, setComponent } from '../bar/utils'

export default {
  name: 'Bar',

  data () {
    return {
      enable: false,
      title: '微课',
      top: true,
      directlyEnterModel: false
    }
  },

  computed: {
    // 金山贷款app 客户端中展示顶部占位条
    isPlaceholderVisible () {
      return window.jsBridge ? window.jsBridge.getEmbedStatusBar() : false
    }
  },

  methods: {
    back () {
      if (this.directlyEnterModel && !this.top) {
        this.$router.push({ name: 'recommend' })
        this.directlyEnterModel = false
      } else if (this.top) {
        if (os.name === 'loan') {
          window.jsBridge.destroyActivity()
        } else {
          os.sdk.view.back(true)
        }
      } else {
        this.$router.back()
      }
    },

    setRouter (name, title) {
      this.top = isTop(name)
      this.title = title
    }
  },

  mounted () {
    let enable = false

    setComponent(this)

    setTimeout(() => {
      enable = os.type === 'app' || os.name === 'loan'

      if (os.type === 'app') {
        if (os.name === 'android' || os.name === 'ios') {
          enable = false
        }

        if (this.$route.path === '/vip-activity') {
          enable = false
        }
      }

      this.enable = enable
      
      // 测试
      // this.enable = true
    }, 300)

    // 暴露到全局供 app 调用，以满足物理（虚拟）返回键与 bar 的返回一致
    if (window) {
      window.appBack = this.back
    }

    this.$nextTick(() => {
      this.setRouter(this.$route.name, this.$route.meta.title)

      barBus.$on('directlyEnter', (current) => {
        if (!this.top) this.directlyEnterModel = true
      })

      barBus.$on('routerChange', (current) => {
        const { name, meta: { title } } = current

        this.setRouter(name, title)
      })

      barBus.$on('setTitle', (title) => {
        this.title = title
      })

      barBus.$on('hideBar', () => {
        this.enable = false
      })

      barBus.$on('showBar', () => {
        this.enable = true
      })
    })
  }
}
</script>

<style lang="scss">
@charset "UTF-8";
@import "../style/main";

$loanHolderHeight: rem(40);
$largeBarHeight: rem(140);

.bar {
  height: rem(100);
  width: 100%;

  &.bar-large {
    height: $largeBarHeight;
  }

  nav {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    background-color: #F4484C;
    height: rem(100);
    width: 100%;
    user-select: none;

    &.bar-large {
      height: $largeBarHeight;
    }

    .loan-holder {
      height: $loanHolderHeight;
      background-color: #f4484c;
    }

    img {
      position: absolute;
      top: 0; bottom: 0;
      left: rem(32);
      margin: auto 0;
      height: rem(40);
      width: rem(38);
    }

    h1 {
      display: inline-block;
      height: rem(100);
      width: rem(600);
      margin-left: rem(100);
      line-height: rem(100);
      color: #fff;
      font-size: rem(40);
      font-weight: 400;
      user-select: none;
    }
  }
}
</style>
